import { createClient } from "@supabase/supabase-js";

const rawSupabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const pastedAssignment = rawSupabaseUrl?.match(
  /^(https?:\/\/\S+)\s+NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY=(sb_publishable_[A-Za-z0-9_-]+)$/,
);
const supabaseUrl = pastedAssignment?.[1] ?? rawSupabaseUrl;
const publicKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim() ||
  import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ||
  pastedAssignment?.[2];

let supabase: ReturnType<typeof createClient> | null = null;
let supabaseConfigError: string | null = null;
let supabaseConfigWarning: string | null = null;

if (pastedAssignment) {
  supabaseConfigWarning =
    "Sign-in is ready, but a setup issue needs attention. Please contact support if you have trouble.";
  console.warn("A Supabase setting was pasted into the wrong Netlify field; the app recovered automatically.");
}

if (!supabaseUrl || !publicKey) {
  supabaseConfigError = "Sign-in is not set up yet. Please try again later.";
} else {
  try {
    const parsedUrl = new URL(supabaseUrl);
    const isHttp = parsedUrl.protocol === "https:" || parsedUrl.protocol === "http:";
    const isProjectOriginOnly =
      parsedUrl.hostname.length > 0 &&
      parsedUrl.pathname === "/" &&
      !parsedUrl.search &&
      !parsedUrl.hash;

    if (!isHttp || !isProjectOriginOnly) {
      throw new Error("The value must be only the Supabase Project URL, with no extra text.");
    }

    supabase = createClient(supabaseUrl, publicKey, {
      auth: {
        autoRefreshToken: true,
        detectSessionInUrl: false,
        persistSession: true,
        flowType: "pkce",
      },
    });
  } catch (error) {
    const reason = error instanceof Error ? error.message : String(error);
    supabaseConfigError = "Sign-in is temporarily unavailable. Please try again later.";
    console.error("Supabase client was not initialized:", reason);
  }
}

export const isSupabaseConfigured = Boolean(supabase);
export { supabase, supabaseConfigError, supabaseConfigWarning };
